import Header from '@/components/components/Header';
import ContainerLayout from '@/components/Layout/ContainerLayout';
import { Paper } from '@/components/Paper';
import { useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useFetchList } from './service'; 
import { Spinner, Box, Icon } from '@chakra-ui/react';
import { WrapperTable } from '@/components/WrapperTable';
import Pagination from '@/components/Paginator';
import SlimTable from '../components/SlimTable';
import { headers, mockData } from './settings';


function ControleLeadTime() {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [visibleHeaders, setVisibleHeaders] = useState(headers);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const printRef = useRef(null);

  const { data, isLoading } = useFetchList({
    page: currentPage - 1,
    size: 20,
    totalCount: 0,
    search: {}, 
  });
  

  return (
    <ContainerLayout>
      <Paper
        m={6}
        bg="white"
        py={4}
        px={2}
        rounded="xl"
        shadow="sm"
        border="1px solid rgba(200, 200, 200, .4)"
        h={'94%'}
      >
        <Header
          onHeadersChange={setVisibleHeaders}
          isFilterVisible={isFilterVisible}
          headers={visibleHeaders}
          isMenuEnabled
          onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
          onView={() => console.log('Visualizar ação executada')}
          printRef={printRef}
          title={'Acompanhamento Portaria - Controle Lead Time'}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <WrapperTable  ref={printRef}>
          {isLoading ? (
            <Box py={10} textAlign="center">
              <Spinner size="lg" />
            </Box>
          ) : (
            <SlimTable
              headers={visibleHeaders}
              showActions={false}
              data={mockData}
            />
            
          )}
        </WrapperTable>
         <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage}/>
        <Outlet />
      </Paper>
    </ContainerLayout>
  );
}

export default ControleLeadTime;
